import { Outlet, useNavigate, Link } from "react-router-dom";
import { LogOut, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="h-20 bg-secondary text-white flex items-center justify-between px-4 sm:px-8">
        <Link to="/portal" className="flex items-center gap-3">
          <img src="/archive/logo.jpg" alt="CG Concrete" className="h-11 w-11 rounded-sm object-contain bg-white p-0.5" />
          <div className="leading-none">
            <div className="font-heading font-extrabold">Client Portal</div>
            <div className="text-[11px] text-white/50 tracking-wider">CG CONCRETE LLC</div>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <span className="text-sm text-white/70 hidden sm:inline">{user?.name}</span>
          <a href="/" className="text-white/70 hover:text-white hidden sm:flex items-center gap-1 text-sm"><Home className="h-4 w-4" /> Site</a>
          <Button onClick={doLogout} variant="outline" size="sm" className="rounded-sm bg-transparent border-white/30 text-white hover:bg-white hover:text-secondary" data-testid="portal-logout"><LogOut className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Log out</span></Button>
        </div>
      </header>
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
